import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './index.less'
import 'lib-flexible';
Vue.config.productionTip = false
import i18n from './i18n';
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
